import { render, staticRenderFns } from "./DayScheduleBlock.vue?vue&type=template&id=8ded45f8&"
import script from "./DayScheduleBlock.vue?vue&type=script&lang=js&"
export * from "./DayScheduleBlock.vue?vue&type=script&lang=js&"
import style0 from "./DayScheduleBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports